import React from 'react'
import Box from "@mui/material/Box";
import { ArrowForward } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import { Button } from '@mui/material';
import SliderImageDownHole from "../../assets/downHoleTools/SliderImage.jpg"

const SliderImage = () => {
  return (
    <Box
    id="image"
    sx={{
      position: "relative",
      height: { xs: 500, sm: 500,md:400 },
      width: "100%",
      backgroundImage: `url(${SliderImageDownHole})`,
      backgroundSize: "cover",
      borderRadius: "4px",
      // outline: "1px solid",
    }}
  >
    <Typography
      variant="h4"
      sx={{
        position: "absolute",
        // bottom: "30%",
        bottom: { xs: "20%", sm: "25%",md:"30%" },
        left: "5%",
        padding: "16px",
        color: "white",
        borderBottomLeftRadius: "10px",
        borderBottomRightRadius: "10px",
        // fontSize: { xs: "1.5rem", sm: "2rem" },
      }}
    >
      {/* <span> Build a better future</span>
      <p style={{ fontSize: "0.9em" }}>
        Integrated technical system of on-site technical service and
        evaluation of oil stabilization and water control effect
      </p> */}
      
      <span style={{ fontSize: "1.5em" }}>Build a better future</span>
      <p style={{ fontSize: "0.5em" }}>
        Integrated technical system of on-site technical service and
        evaluation of oil stabilization and water control effect
      </p> 
      {/* <Button variant="contained" color="primary"   endIcon={<ArrowForward />}>
        Start now
      </Button> */}
    </Typography>
  
     
  </Box>
  )
}

export default SliderImage
